export const TimeUtils = {
  convertToHumanReadableFormat: (unformattedTime) => {
    const date = new Date(unformattedTime);
    const options = {
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    };
    const timeString = date.toLocaleString("en-US", options);
    return timeString;
  },
  generateTimeOptions: (length, interval) => {
    const timeOptions = [];

    for (let i = 0; i < length; i++) {
      const start = 8 + i * interval;
      timeOptions.push({
        end: start + interval,
        start,
      });
    }

    return timeOptions;
  },

  // eslint-disable-next-line sort-keys
  generateOverlappingTimeOptions: function (
    start = 8,
    count = 7,
    interval = 2,
    duration = 4
  ) {
    const timeOptions = [];

    for (let i = 0; i < count; i++) {
      timeOptions.push({
        end: start + i * interval + duration,
        start: start + i * interval,
      });
    }

    return timeOptions;
  },
};
